<template>
  <div id="reposicionFondo">
    <v-flex xs12 sm12 md6>
      <v-select v-model="caja_chica" :items="catalogos.cajas_chicas" item-text="descripcion" item-value="id"
        label="Seleccionar caja chica"></v-select>
    </v-flex>
    <v-expansion-panel v-if="isReady" dark>
      <v-expansion-panel-content>
        <div slot="header">
          <v-toolbar-title>Detalle de Caja chica</v-toolbar-title>
        </div>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md6>
                  <v-container>
                    <h3 class="grey--text">GENERAL</h3><br />
                    <v-radio-group v-model="detalleUsuario.area" disabled :mandatory="false">
                      <div slot="label"><strong>Área</strong></div>
                      <v-radio label="Oficinas administrativas" color="primary"
                        value="oficinas_administrativas"></v-radio>
                      <v-radio label="Oficinas comerciales" color="primary" value="oficinas_comerciales"></v-radio>
                    </v-radio-group>
                    <br />
                    <h3 class="grey--text">RESPONSABLE</h3><br />
                    <v-text-field v-model="detalleUsuario.nombre" label="Nombre" disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.puesto" label="Puesto" disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.departamento" label="Departamento" disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.oficina" label="Oficina" disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.centro" label="Centro de costos" disabled></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-container>
                    <h3 class="grey--text">FONDO FIJO</h3><br />
                    <v-text-field v-model.lazy="detalleUsuario.importe" label="Importe" prefix="$" suffix="MXN"
                      disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.letra" label="Importe con letra" disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.detalle" label="Detalle" disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.empresa" label="Empresa" disabled></v-text-field>
                    <v-text-field v-model="detalleUsuario.observaciones" label="Observaciones" disabled></v-text-field>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <br />
    <v-card class="elevation-12">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Reposiciones</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <v-btn slot="activator" :loading="loading" :disabled="!caja_chica" icon @click="newReplacement()">
            <v-icon>note_add</v-icon>
          </v-btn>
          <span>Nueva Reposición</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-title>
        <v-btn small :loading="loading" color="info" class="white--text" @click="refresh">Actualizar</v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details
          maxlength="200"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="reposiciones" :loading="loading" :search="search"
        rows-per-page-text="Registros por página" :pagination.sync="pagination" class="elevation-1">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center" @click="showDetailRep(props.item.id)">{{ props.item.id_seg }}</td>
          <td class="text-xs-center" @click="showDetailRep(props.item.id)">{{ props.item.tipo_solicitud }}</td>
          <td class="text-xs-center" @click="showDetailRep(props.item.id)">{{ props.item.tipo_pago }}</td>
          <td class="text-xs-center" @click="showDetailRep(props.item.id)">{{ props.item.no_facturas }}</td>
          <td class="text-xs-center" @click="showDetailRep(props.item.id)">$ {{
            props.item.importe_total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
          <td class="text-xs-center" @click="showDetailRep(props.item.id)">{{ props.item.estado }}</td>
          <td class="text-xs-center" @click="showDetailRep(props.item.id)">{{ props.item.fecha_registro }}</td>
        </template>
        <template slot="pageText" slot-scope="props">
          Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
        </template>
        <template slot="no-data">
          <div class="text-xs-center"></div>
        </template>
        <template slot="no-results">
          <div class="text-xs-center">
            No se obtuvieron resultados
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-card v-if="alert">
      <v-toolbar dense dark color="blue-grey">
        <v-toolbar-title>Notificación</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <center>
          <h3 class="headline">{{ msgError }}</h3>
        </center>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="blue-grey" @click.native="newRequest()">Solicitar</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogNewRep" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Solicitud de reposición fondo fijo de caja</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat :loading="loading" @click="questionRep = true">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">GENERAL</h3><br />
                  <v-radio-group v-model="reposicion.tipoSolicitud" :error-messages="tipoSolicitudErrors"
                    :mandatory="false" @input="$v.reposicion.tipoSolicitud.$touch()"
                    @blur="$v.reposicion.tipoSolicitud.$touch()">
                    <div slot="label"><strong>Tipo de solicitud</strong></div>
                    <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                    <v-radio label="Depósito electrónico" color="primary" value="deposito_electronico"></v-radio>
                  </v-radio-group>
                  <v-radio-group v-model="reposicion.tipoPago" :error-messages="tipoPagoErrors" :mandatory="false"
                    @input="$v.reposicion.tipoPago.$touch()" @blur="$v.reposicion.tipoPago.$touch()">
                    <div slot="label"><strong>Tipo de pago</strong></div>
                    <v-radio label="Gastos comprobables" color="primary" value="gastos_comprobables"></v-radio>
                    <v-radio label="Otros" color="primary" value="otros"></v-radio>
                  </v-radio-group><br />
                  <v-text-field v-model="reposicion.monto" :error-messages="montoErrors" label="Fondo fijo autorizado"
                    @input="$v.reposicion.monto.$touch()" @blur="$v.reposicion.monto.$touch()" box prefix="$"
                    suffix="MXN" readonly></v-text-field>
                  <br />
                  <template v-if="reposicion.tipoSolicitud === 'deposito_electronico'">
                    <h3 class="grey--text">DATOS DE DEPÓSITO</h3><br />
                    <v-text-field v-model="reposicion.banco" :error-messages="bancoErrors" label="Banco"
                      @input="$v.reposicion.banco.$touch()" @blur="$v.reposicion.banco.$touch()" box
                      readonly></v-text-field>
                    <v-text-field v-model="reposicion.cuenta" :error-messages="cuentaErrors" label="No. Cuenta"
                      @input="$v.reposicion.cuenta.$touch()" @blur="$v.reposicion.cuenta.$touch()" box
                      readonly></v-text-field>
                    <v-text-field v-model="reposicion.tarjeta" :error-messages="tarjetaErrors" label="No. Tarjeta"
                      @input="$v.reposicion.tarjeta.$touch()" @blur="$v.reposicion.tarjeta.$touch()" box
                      readonly></v-text-field>
                    <v-text-field v-model="reposicion.clabe" :error-messages="clabeErrors"
                      label="Referencia interbancaria" @input="$v.reposicion.clabe.$touch()"
                      @blur="$v.reposicion.clabe.$touch()" box readonly></v-text-field>
                  </template>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DE CAJA CHICA</h3><br />
                  <v-text-field v-model="reposicion.empresa" :error-messages="empresaErrors" label="Empresa"
                    @input="$v.reposicion.empresa.$touch()" @blur="$v.reposicion.empresa.$touch()" box
                    readonly></v-text-field>
                  <br />
                  <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br />
                  <v-text-field v-model="reposicion.unidad" :error-messages="unidadErrors" label="Unidad de negocio"
                    @input="$v.reposicion.unidad.$touch()" @blur="$v.reposicion.unidad.$touch()" box
                    readonly></v-text-field>
                  <v-text-field v-model="reposicion.plaza" :error-messages="plazaErrors" label="Plaza"
                    @input="$v.reposicion.plaza.$touch()" @blur="$v.reposicion.plaza.$touch()" box
                    readonly></v-text-field>
                  <v-text-field v-model="reposicion.centro" :error-messages="centroErrors" label="Centro de costos"
                    @input="$v.reposicion.centro.$touch()" @blur="$v.reposicion.centro.$touch()" box
                    readonly></v-text-field>
                  <v-text-field v-model="reposicion.beneficiario" :error-messages="beneficiarioErrors"
                    label="Beneficiario" @input="$v.reposicion.beneficiario.$touch()"
                    @blur="$v.reposicion.beneficiario.$touch()" box readonly></v-text-field>
                  <br />
                  <h3 class="grey--text">FACTURAS</h3><br />
                  <v-text-field v-model="reposicion.facturas.no_facturas" class="pt-3" label="No. Facturas" box
                    readonly></v-text-field>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-btn small block color="blue-grey" class="white--text" @click="dialogNewFac = true">
                        Agregar
                        <v-icon small right dark>add_circle</v-icon>
                      </v-btn><br />
                      <v-text-field v-model="reposicion.facturas.subtotal" label="Subtotal" box prefix="$" suffix="MXN"
                        readonly></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <div class="text-xs-center">
                        <v-menu transition="slide-y-transition" top left offset-y full-width>
                          <v-btn slot="activator" :disabled="reposicion.facturas.detalle.length == 0" small block
                            color="blue-grey" class="white--text">
                            Mostrar
                            <v-icon small right dark>remove_red_eye</v-icon>
                          </v-btn>
                          <v-list v-if="reposicion.facturas.detalle.length > 0">
                            <v-list-tile v-for="(fac, idx) in reposicion.facturas.detalle" :key="idx"
                              @click="showDetailFac(idx)">
                              <v-list-tile-title
                                v-text="catalogos.conceptos.filter(concepto => { return concepto.id == fac.concepto })[0].descripcion"></v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div><br />
                      <v-text-field v-model="reposicion.facturas.iva" label="IVA" box prefix="$" suffix="MXN"
                        readonly></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-text-field v-model="reposicion.facturas.importe_total" :error-messages="importeTotalErrors"
                    label="Importe por reembolsar" @input="$v.reposicion.facturas.importe_total.$touch()"
                    @blur="$v.reposicion.facturas.importe_total.$touch()" prefix="$" suffix="MXN" box
                    readonly></v-text-field>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewFac" width="500" :persistent="true">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Nueva Factura</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ reposicion.facturas.no_facturas + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="reposicion.facturas.nueva.tipo_gasto" :error-messages="tipoGastoErrors"
              :mandatory="false" @input="$v.reposicion.facturas.nueva.tipo_gasto.$touch()"
              @blur="$v.reposicion.facturas.nueva.tipo_gasto.$touch()">
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.pdf" v-show="gastoDeducible" @click="$refs.pdf.click()">
                  PDF
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="pdf" type="file" @change="readFile('pdf')">
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.xml" v-show="gastoDeducible" @click="$refs.xml.click()">
                  XML
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
                <input v-show="false" ref="xml" type="file" @change="readFile('xml')">
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-btn block round :color="color.foto" v-show="!gastoDeducible" @click="$refs.foto.click()">
                  Foto
                  <v-icon right dark>attach_file</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <input v-show="false" ref="foto" type="file" @change="readFile('foto')"><br />
            <v-select v-model="reposicion.facturas.nueva.centro" :items="catalogos.centros" item-text="descripcion"
              item-value="id" label="Centro de costos"></v-select>
            <v-select v-model="reposicion.facturas.nueva.concepto" :error-messages="conceptoErrors"
              :items="catalogos.conceptos" @input="$v.reposicion.facturas.nueva.concepto.$touch()"
              @blur="$v.reposicion.facturas.nueva.concepto.$touch()" item-text="descripcion" item-value="id"
              label="Concepto" readonly></v-select>
            <v-text-field v-model="reposicion.facturas.nueva.razon_social" v-show="gastoDeducible"
              :error-messages="razonSocialErrors" @input="$v.reposicion.facturas.nueva.razon_social.$touch()"
              @blur="$v.reposicion.facturas.nueva.razon_social.$touch()" label="Razón Social" readonly></v-text-field>
            <v-text-field v-model="reposicion.facturas.nueva.rfc" v-show="gastoDeducible" :error-messages="rfcErrors"
              @input="$v.reposicion.facturas.nueva.rfc.$touch()" @blur="$v.reposicion.facturas.nueva.rfc.$touch()"
              label="RFC" readonly></v-text-field>
            <v-text-field v-model="reposicion.facturas.nueva.no_factura" v-show="gastoDeducible"
              :error-messages="noFacturaErrors" @input="$v.reposicion.facturas.nueva.no_factura.$touch()"
              @blur="$v.reposicion.facturas.nueva.no_factura.$touch()" label="No. Factura"
              :readonly="!editNoFactura"></v-text-field>
            <v-checkbox v-model="reposicion.facturas.nueva.proveedor_frontera" v-show="!gastoDeducible"
              label="Proveedor de frontera" color="primary"></v-checkbox>
            <v-text-field v-model="reposicion.facturas.nueva.importe" :error-messages="importeErrors"
              @input="$v.reposicion.facturas.nueva.importe.$touch()"
              @blur="$v.reposicion.facturas.nueva.importe.$touch()" label="Importe" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field :disabled="gastoNoDeducible" v-model="reposicion.facturas.nueva.descuento"
              :error-messages="descuentoErrors" @input="$v.reposicion.facturas.nueva.descuento.$touch()"
              @blur="$v.reposicion.facturas.nueva.descuento.$touch()" label="Descuento" prefix="$" suffix="MXN"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field :disabled="gastoNoDeducible" v-model="reposicion.facturas.nueva.iva"
              :error-messages="ivaErrors" @input="$v.reposicion.facturas.nueva.iva.$touch()"
              @blur="$v.reposicion.facturas.nueva.iva.$touch()" label="IVA" prefix="$" suffix="MXN" :value="iva"
              :readonly="gastoDeducible"></v-text-field>
            <v-text-field v-if="isNewFac" v-model="reposicion.facturas.nueva.total" label="Total" :value="total"
              prefix="$" suffix="MXN" readonly></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat v-show="!loading" color="blue-grey" @click.native="closeNewFac()">Cancelar</v-btn>
          <v-btn dark color="blue-grey" :loading="loading" @click.native="saveNewFac()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetFac" width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Detalle de Factura</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>No. {{ detalleFactura.index + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="detalleFactura.tipo_gasto" :mandatory="false" disabled>
              <div slot="label"><strong>Tipo de gasto</strong></div>
              <v-radio label="Deducible" color="primary" value="deducible"></v-radio>
              <v-radio label="No deducible" color="primary" value="no_deducible"></v-radio>
            </v-radio-group>
            <v-layout wrap>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('pdf')">
                  PDF
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('xml')">
                  XML
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-btn flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument('foto')">
                  Foto
                  <v-icon right dark>cloud_download</v-icon>
                </v-btn>
              </v-flex>
            </v-layout><br />
            <v-text-field v-model="detalleFactura.centro" class="pt-4" label="Centro de costos" disabled></v-text-field>
            <v-text-field v-model="detalleFactura.concepto" class="pt-4" label="Concepto" disabled></v-text-field>
            <v-text-field v-model="detalleFactura.razon_social" class="pt-4" label="Razón Social"
              disabled></v-text-field>
            <v-text-field v-model="detalleFactura.rfc" class="pt-4" label="RFC" disabled></v-text-field>
            <v-text-field v-model="detalleFactura.no_factura" class="pt-4" label="No. Factura" disabled></v-text-field>
            <v-text-field v-model="detalleFactura.importe" class="pt-4" label="Importe" prefix="$" suffix="MXN"
              disabled></v-text-field>
            <v-text-field v-model="detalleFactura.descuento" class="pt-4" label="Descuento" prefix="$" suffix="MXN"
              disabled></v-text-field>
            <v-text-field v-model="detalleFactura.iva" class="pt-4" label="IVA" prefix="$" suffix="MXN"
              disabled></v-text-field>
            <v-text-field v-model="detalleFactura.total" class="pt-4" label="Total" prefix="$" suffix="MXN"
              disabled></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="dialogNewRep" flat color="error" @click.native="questionFac = true">Eliminar</v-btn>
          <v-btn flat color="blue-grey" @click.native="closeDetailFac()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDetRep" fullscreen hide-overlay :persistent="true" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-btn icon dark :disabled="loading" @click="closeDetailRep()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>Detalle de reposición fondo fijo de caja</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip left>
              <v-btn slot="activator" :loading="loading" icon @click="print()">
                <v-icon>local_printshop</v-icon>
              </v-btn>
              <span>Imprimir</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">GENERAL</h3><br />
                  <v-radio-group v-model="detalleReposicion.general.tipoSolicitud" disabled>
                    <div slot="label"><strong>Tipo de solicitud</strong></div>
                    <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                    <v-radio label="Depósito electrónico" color="primary" value="deposito_electronico"></v-radio>
                  </v-radio-group>
                  <v-radio-group v-model="detalleReposicion.general.tipoPago" disabled>
                    <div slot="label"><strong>Tipo de pago</strong></div>
                    <v-radio label="Gastos comprobables" color="primary" value="gastos_comprobables"></v-radio>
                    <v-radio label="Otros" color="primary" value="otros"></v-radio>
                  </v-radio-group><br />
                  <v-text-field v-model="reposicion.monto" box prefix="$" suffix="MXN" label="Fondo fijo autorizado"
                    disabled></v-text-field>
                  <br />
                  <template v-if="detalleReposicion.general.tipoSolicitud === 'deposito_electronico'">
                    <h3 class="grey--text">DATOS DE DEPÓSITO</h3><br />
                    <v-text-field v-model="detalleReposicion.general.banco" box label="Banco" disabled></v-text-field>
                    <v-text-field v-model="detalleReposicion.general.cuenta" box label="No. Cuenta"
                      disabled></v-text-field>
                    <v-text-field v-model="detalleReposicion.general.tarjeta" box label="No. Tarjeta"
                      disabled></v-text-field>
                    <v-text-field v-model="detalleReposicion.general.clabe" box label="Referencia interbancaria"
                      disabled></v-text-field><br />
                  </template>
                  <h3 class="grey--text">FIRMAS</h3><br />
                  <v-list three-line dark>
                    <template v-for="(item, i) in detalleReposicion.firmas">
                      <v-list-tile class="pb-2 pt-2">
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                          <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                            v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider v-show="(i + 1) < detalleReposicion.firmas.length"></v-divider>
                    </template>
                  </v-list>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">DATOS DE CAJA CHICA</h3><br />
                  <v-text-field v-model="reposicion.empresa" label="Empresa" box disabled></v-text-field>
                  <br />
                  <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br />
                  <v-text-field v-model="reposicion.unidad" label="Unidad de negocio" box disabled></v-text-field>
                  <v-text-field v-model="reposicion.plaza" label="Plaza" box disabled></v-text-field>
                  <v-text-field v-model="reposicion.centro" label="Centro de costos" box disabled></v-text-field>
                  <v-text-field v-model="reposicion.beneficiario" label="Beneficiario" box disabled></v-text-field>
                  <br />
                  <h3 class="grey--text">FACTURAS</h3><br />
                  <v-text-field v-model="detalleReposicion.resumen.no_facturas" class="pt-3" label="No. Facturas" box
                    disabled></v-text-field>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                      <v-btn small block color="blue-grey" class="white--text" disabled>
                        Agregar
                        <v-icon small right dark>add_circle</v-icon>
                      </v-btn><br />
                      <v-text-field v-model="detalleReposicion.resumen.subtotal" label="Subtotal" box prefix="$"
                        suffix="MXN" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                      <div class="text-xs-center">
                        <v-menu transition="slide-y-transition" top left offset-y full-width>
                          <v-btn slot="activator" :disabled="detalleReposicion.facturas.length == 0" small block
                            color="blue-grey" class="white--text">
                            Mostrar
                            <v-icon small right dark>remove_red_eye</v-icon>
                          </v-btn>
                          <v-list v-if="detalleReposicion.facturas.length > 0">
                            <v-list-tile v-for="(fac, idx) in detalleReposicion.facturas" :key="idx"
                              @click="showFacDetailRep(idx)">
                              <v-list-tile-title v-text="fac.concepto"></v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div><br />
                      <v-text-field v-model="detalleReposicion.resumen.iva" label="IVA" box prefix="$" suffix="MXN"
                        disabled></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-text-field v-model="detalleReposicion.general.importe_total" label="Importe por reembolsar"
                    prefix="$" suffix="MXN" box disabled></v-text-field>
                  <br />
                  <h3 class="grey--text">RESUMEN</h3><br />
                  <v-data-table v-if="tableResumen.length" :headers="headersResumen" :items="tableResumen"
                    class="elevation-1" hide-actions no-data-text="">
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-right">{{ props.item.tipo_gasto }}</td>
                      <td class="text-xs-right">{{ props.item.concepto }}</td>
                      <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                      <!--<td class="text-xs-right">{{ props.item.proveedor }}</td>-->
                      <td class="text-xs-right">{{ props.item.subtotal }}</td>
                      <td class="text-xs-right">{{ props.item.iva }}</td>
                      <td class="text-xs-right">{{ props.item.total }}</td>
                    </template>
                  </v-data-table>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionRep" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea confirmar la solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionRep = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="save()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionFac" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea eliminar la factura?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionFac = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="removeElement()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import services from "@/config/services";
import axios from "axios";
import download from "downloadjs";
import moment from "moment";
import { validationMixin } from "vuelidate";
import {
  decimal,
  maxLength,
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "reposicionFondo",
  mixins: [validationMixin],
  validations: {
    reposicion: {
      tipoSolicitud: {
        required: requiredIf(function () {
          return !this.isNewFac;
        })
      },
      tipoPago: {
        required: requiredIf(function () {
          return !this.isNewFac;
        })
      },
      monto: { required },
      banco: {
        required: requiredIf(function () {
          return this.isDepElec && !this.isNewFac;
        })
      },
      cuenta: {
        required: requiredIf(function () {
          return this.isDepElec && !this.isNewFac;
        })
      },
      tarjeta: {
        required: requiredIf(function () {
          return this.isDepElec && !this.isNewFac;
        })
      },
      clabe: {
        required: requiredIf(function () {
          return this.isDepElec && !this.isNewFac;
        })
      },
      empresa: { required },
      unidad: { required },
      plaza: { required },
      centro: { required },
      beneficiario: { required },
      facturas: {
        importe_total: {
          required: requiredIf(function () {
            return !this.isNewFac;
          }),
          decimal,
          minValue: minValue(0.01),
          maxValue: maxValue(999999.99)
        },
        nueva: {
          tipo_gasto: {
            required: requiredIf(function () {
              return this.isNewFac;
            })
          },
          concepto: {
            required: requiredIf(function () {
              return this.isNewFac;
            })
          },
          razon_social: {
            required: requiredIf(function () {
              return this.gastoDeducible;
            }),
            maxLength: maxLength(100)
          },
          rfc: {
            required: requiredIf(function () {
              return this.gastoDeducible;
            }),
            maxLength: maxLength(13)
          },
          no_factura: {
            required: requiredIf(function () {
              return this.gastoDeducible;
            }),
            maxLength: maxLength(60)
          },
          proveedor_frontera: {
            required: requiredIf(function () {
              return this.gastoNoDeducible;
            })
          },
          importe: {
            required: requiredIf(function () {
              return this.isNewFac;
            }),
            decimal,
            minValue: minValue(0.01),
            maxValue: maxValue(999999.99)
          },
          descuento: {
            required: requiredIf(function () {
              return this.isNewFac;
            }),
            decimal,
            minValue: minValue(0),
            maxValue: maxValue(999999.99)
          },
          iva: {
            required: requiredIf(function () {
              return this.isNewFac;
            }),
            decimal,
            minValue: minValue(0),
            maxValue: maxValue(999999.99)
          },
          total: {
            required: requiredIf(function () {
              return this.isNewFac;
            }),
            decimal,
            minValue: minValue(0.01),
            maxValue: maxValue(999999.99)
          }
        }
      }
    }
  },
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: "",
    msgError: "",
    alert: false,
    isReady: false,
    dialogAlert: false,
    dialogNewRep: false,
    dialogNewFac: false,
    dialogDetFac: false,
    dialogDetRep: false,
    questionRep: false,
    questionFac: false,
    search: "",
    pagination: {
      rowsPerPage: 7
    },
    headers: [
      { text: "Id", align: "center", sortable: false, value: "id_seg" },
      {
        text: "Tipo de Solicitud",
        align: "center",
        sortable: false,
        value: "tipo_solicitud"
      },
      {
        text: "Tipo de Pago",
        align: "center",
        sortable: false,
        value: "tipo_pago"
      },
      {
        text: "No. Facturas",
        align: "center",
        sortable: false,
        value: "no_facturas"
      },
      {
        text: "Importe Total",
        align: "center",
        sortable: false,
        value: "importe_total"
      },
      { text: "Estado", align: "center", sortable: false, value: "estado" },
      {
        text: "Fecha de Registro",
        align: "center",
        sortable: false,
        value: "fecha_registro"
      }
    ],
    headersResumen: [
      {
        text: "TIPO DE GASTO",
        align: "center",
        sortable: false,
        value: "tipo_gasto"
      },
      { text: "CONCEPTO", align: "center", sortable: false, value: "concepto" },
      {
        text: "FECHA DE TIMBRADO",
        align: "center",
        sortable: false,
        value: "fecha_timbrado"
      },
      /*{ text: 'PROVEEDOR', align: 'center', sortable: false, value: 'proveedor' },*/
      {
        text: "SUB TOTAL",
        align: "center",
        sortable: false,
        value: "subtotal"
      },
      { text: "IVA", align: "center", sortable: false, value: "iva" },
      { text: "TOTAL", align: "center", sortable: false, value: "total" }
    ],
    catalogos: {
      centros: [],
      conceptos: [],
      conceptos_sat: [],
      cajas_chicas: []
    },
    caja_chica: null,
    reposiciones: [],
    detalleUsuario: {
      area: null,
      nombre: "",
      puesto: "",
      departamento: "",
      oficina: "",
      centro: "",
      importe: "",
      detalle: "",
      empresa: "",
      observaciones: ""
    },
    color: {
      pdf: "",
      xml: "",
      foto: ""
    },
    reposicion: {
      tipoSolicitud: null,
      tipoPago: null,
      monto: "",
      banco: "",
      cuenta: "",
      tarjeta: "",
      clabe: "",
      empresa: "",
      unidad: "",
      plaza: "",
      centro: "",
      beneficiario: "",
      facturas: {
        importe_total: "",
        no_facturas: 0,
        subtotal: 0,
        iva: 0,
        nueva: {
          tipo_gasto: "deducible",
          pdf: { nombre: "", data: null },
          xml: { nombre: "", data: null },
          foto: { nombre: "", data: null },
          centro: null,
          concepto: "",
          razon_social: "",
          rfc: "",
          no_factura: "",
          fecha_timbrado: "",
          proveedor_frontera: false,
          importe: "",
          descuento: "",
          iva: "",
          total: ""
        },
        detalle: []
      }
    },
    detalleFactura: {
      index: "",
      tipo_gasto: null,
      pdf: { nombre: "", data: null },
      xml: { nombre: "", data: null },
      foto: { nombre: "", data: null },
      centro: null,
      concepto: "",
      razon_social: "",
      rfc: "",
      no_factura: "",
      fecha_timbrado: "",
      proveedor_frontera: false,
      importe: "",
      descuento: "",
      iva: "",
      total: ""
    },
    detalleReposicion: {
      general: {
        tipoSolicitud: null,
        tipoPago: null,
        monto: "",
        banco: "",
        cuenta: "",
        tarjeta: "",
        clabe: "",
        importe_total: ""
      },
      facturas: [],
      resumen: {
        no_facturas: 0,
        subtotal: 0,
        iva: 0
      },
      firmas: []
    },
    idElementoSeleccionado: null,
    editNoFactura: false
  }),
  watch: {
    caja_chica(val) {
      if (val) {
        this.detailRequest();
      }
    },
    "reposicion.facturas.nueva.tipo_gasto"(val) {
      this.$v.$reset();
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.reposicion.facturas.nueva.centro = null;
      this.reposicion.facturas.nueva.concepto = "";
      this.reposicion.facturas.nueva.razon_social = "";
      this.reposicion.facturas.nueva.rfc = "";
      this.reposicion.facturas.nueva.no_factura = "";
      this.reposicion.facturas.nueva.fecha_timbrado = "";
      this.reposicion.facturas.nueva.proveedor_frontera = false;
      this.reposicion.facturas.nueva.importe = "";
      this.reposicion.facturas.nueva.descuento = "0";
      this.reposicion.facturas.nueva.iva = "0";
      this.reposicion.facturas.nueva.total = "";
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      if (val === "no_deducible") {
        for (let i = 0; i < this.catalogos.conceptos.length; i++) {
          if (
            this.catalogos.conceptos[i].cuenta == "12202" &&
            this.catalogos.conceptos[i].subcuenta == "000000"
          ) {
            this.reposicion.facturas.nueva.concepto = this.catalogos.conceptos[
              i
            ].id;
          }
        }
      }
    }
  },
  mounted() {
    this.loading = true;
    this.ws("get", "detalleUsuario")
      .then(res => {
        if (res.ok) {
          this.prepareForm(res.data);
        } else {
          this.error = true;
          this.msgError = res.message;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    gastoNoDeducible() {
      const aux = this.reposicion.facturas.nueva.tipo_gasto === "no_deducible";
      if (aux) {
        this.reposicion.facturas.nueva.iva = 0;
        this.reposicion.facturas.nueva.descuento = 0;
      }
      return aux;
    },
    tipoSolicitudErrors() {
      const errors = [];
      if (!this.$v.reposicion.tipoSolicitud.$dirty) return errors;
      !this.$v.reposicion.tipoSolicitud.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tipoPagoErrors() {
      const errors = [];
      if (!this.$v.reposicion.tipoPago.$dirty) return errors;
      !this.$v.reposicion.tipoPago.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    montoErrors() {
      const errors = [];
      if (!this.$v.reposicion.monto.$dirty) return errors;
      !this.$v.reposicion.monto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    bancoErrors() {
      const errors = [];
      if (!this.$v.reposicion.banco.$dirty) return errors;
      !this.$v.reposicion.banco.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    cuentaErrors() {
      const errors = [];
      if (!this.$v.reposicion.cuenta.$dirty) return errors;
      !this.$v.reposicion.cuenta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tarjetaErrors() {
      const errors = [];
      if (!this.$v.reposicion.cuenta.$dirty) return errors;
      !this.$v.reposicion.cuenta.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    clabeErrors() {
      const errors = [];
      if (!this.$v.reposicion.clabe.$dirty) return errors;
      !this.$v.reposicion.clabe.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    empresaErrors() {
      const errors = [];
      if (!this.$v.reposicion.empresa.$dirty) return errors;
      !this.$v.reposicion.empresa.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    unidadErrors() {
      const errors = [];
      if (!this.$v.reposicion.unidad.$dirty) return errors;
      !this.$v.reposicion.unidad.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    plazaErrors() {
      const errors = [];
      if (!this.$v.reposicion.plaza.$dirty) return errors;
      !this.$v.reposicion.plaza.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    centroErrors() {
      const errors = [];
      if (!this.$v.reposicion.centro.$dirty) return errors;
      !this.$v.reposicion.centro.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    beneficiarioErrors() {
      const errors = [];
      if (!this.$v.reposicion.beneficiario.$dirty) return errors;
      !this.$v.reposicion.beneficiario.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    importeTotalErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.importe_total.$dirty) return errors;
      !this.$v.reposicion.facturas.importe_total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.reposicion.facturas.importe_total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.reposicion.facturas.importe_total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.reposicion.facturas.importe_total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    tipoGastoErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.tipo_gasto.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.tipo_gasto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    conceptoErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.concepto.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.concepto.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    razonSocialErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.razon_social.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.razon_social.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.reposicion.facturas.nueva.razon_social.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    rfcErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.rfc.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.rfc.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.reposicion.facturas.nueva.rfc.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    noFacturaErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.no_factura.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.no_factura.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.reposicion.facturas.nueva.no_factura.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    importeErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.importe.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.importe.decimal &&
        errors.push("El campo es inválido");
      !this.$v.reposicion.facturas.nueva.importe.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.reposicion.facturas.nueva.importe.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.reposicion.facturas.nueva.importe.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    descuentoErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.descuento.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.descuento.decimal &&
        errors.push("El campo es inválido");
      !this.$v.reposicion.facturas.nueva.descuento.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.reposicion.facturas.nueva.descuento.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.reposicion.facturas.nueva.descuento.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    ivaErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.iva.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.iva.decimal &&
        errors.push("El campo es inválido");
      !this.$v.reposicion.facturas.nueva.iva.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.reposicion.facturas.nueva.iva.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.reposicion.facturas.nueva.iva.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    totalErrors() {
      const errors = [];
      if (!this.$v.reposicion.facturas.nueva.total.$dirty) return errors;
      !this.$v.reposicion.facturas.nueva.total.decimal &&
        errors.push("El campo es inválido");
      !this.$v.reposicion.facturas.nueva.total.minValue &&
        errors.push("El campo no alcanza el valor mínimo");
      !this.$v.reposicion.facturas.nueva.total.maxValue &&
        errors.push("El campo excede el valor máximo");
      !this.$v.reposicion.facturas.nueva.total.required &&
        errors.push("El campo es obligatorio");
      return errors;
    },
    isDepElec() {
      return this.reposicion.tipoSolicitud === "deposito_electronico"
        ? true
        : false;
    },
    isNewFac() {
      return this.dialogNewFac;
    },
    gastoDeducible() {
      return (
        this.dialogNewFac &&
        this.reposicion.facturas.nueva.tipo_gasto === "deducible"
      );
    },
    gastoNoDeducible() {
      return (
        this.dialogNewFac &&
        this.reposicion.facturas.nueva.tipo_gasto === "no_deducible"
      );
    },
    iva() {
      if (this.gastoNoDeducible) {
        return 0;
      }
      if (
        this.dialogNewFac &&
        this.reposicion.facturas.nueva.tipo_gasto === "no_deducible"
      ) {
        let factor = this.reposicion.facturas.nueva.proveedor_frontera
          ? 0.08
          : 0.16;
        let importe = parseFloat(
          parseFloat(this.reposicion.facturas.nueva.importe).toFixed(2)
        );
        let descuento = parseFloat(
          parseFloat(this.reposicion.facturas.nueva.descuento).toFixed(2)
        );
        importe = isNaN(importe) ? 0 : importe;
        descuento = isNaN(descuento) ? 0 : descuento;
        let iva = parseFloat((importe - descuento) * factor).toFixed(2);
        this.reposicion.facturas.nueva.iva = iva;
      }
    },
    total() {
      if (
        this.dialogNewFac &&
        this.reposicion.facturas.nueva.tipo_gasto === "no_deducible"
      ) {
        let importe = parseFloat(
          parseFloat(this.reposicion.facturas.nueva.importe).toFixed(2)
        );
        let descuento = parseFloat(
          parseFloat(this.reposicion.facturas.nueva.descuento).toFixed(2)
        );
        let iva = parseFloat(
          parseFloat(this.reposicion.facturas.nueva.iva).toFixed(2)
        );
        importe = isNaN(importe) ? 0 : importe;
        descuento = isNaN(descuento) ? 0 : descuento;
        iva = isNaN(iva) ? 0 : iva;
        this.reposicion.facturas.nueva.total = parseFloat(
          importe - descuento + iva
        ).toFixed(2);
      }
    },
    tableResumen() {
      let resumen = [];
      let detalle = {};
      for (let i = 0; i < this.detalleReposicion.facturas.length; i++) {
        let tipo_gasto = this.detalleReposicion.facturas[i].tipo_gasto;
        let concepto = this.detalleReposicion.facturas[i].concepto;
        let fecha_timbrado = this.detalleReposicion.facturas[i].fecha_timbrado;
        let proveedor = this.detalleReposicion.facturas[i].razon_social;
        let subtotal = this.detalleReposicion.facturas[i].importe;
        let iva = this.detalleReposicion.facturas[i].iva;
        let total = this.detalleReposicion.facturas[i].total;
        if (tipo_gasto === "deducible") {
          tipo_gasto = "DEDUCIBLE";
        } else if (tipo_gasto === "no_deducible") {
          tipo_gasto = "NO DEDUCIBLE";
        }
        if (!detalle[tipo_gasto]) {
          detalle[tipo_gasto] = {};
        }
        if (!detalle[tipo_gasto][concepto]) {
          detalle[tipo_gasto][concepto] = {
            fecha_timbrado: fecha_timbrado,
            proveedor: proveedor,
            subtotal: 0,
            iva: 0,
            total: 0
          };
        }
        detalle[tipo_gasto][concepto].subtotal += subtotal;
        detalle[tipo_gasto][concepto].iva += iva;
        detalle[tipo_gasto][concepto].total += total;
      }
      let keysTipoGasto = Object.keys(detalle);
      for (let i = 0; i < keysTipoGasto.length; i++) {
        let keysConcepto = Object.keys(detalle[keysTipoGasto[i]]);
        for (let j = 0; j < keysConcepto.length; j++) {
          resumen.push({
            tipo_gasto: keysTipoGasto[i],
            concepto: keysConcepto[j],
            fecha_timbrado:
              detalle[keysTipoGasto[i]][keysConcepto[j]].fecha_timbrado,
            proveedor: detalle[keysTipoGasto[i]][keysConcepto[j]].proveedor,
            subtotal: detalle[keysTipoGasto[i]][keysConcepto[j]].subtotal,
            iva: detalle[keysTipoGasto[i]][keysConcepto[j]].iva,
            total: detalle[keysTipoGasto[i]][keysConcepto[j]].total
          });
        }
      }
      for (let i = 0; i < resumen.length; i++) {
        resumen[i].fecha_timbrado = resumen[i].fecha_timbrado.split("T")[0];
        resumen[i].subtotal =
          "$" +
          resumen[i].subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        resumen[i].iva =
          "$" + resumen[i].iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        resumen[i].total =
          "$" +
          resumen[i].total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return resumen;
    }
  },
  methods: {
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    refresh() {
      let id = this.caja_chica;
      if (id) {
        this.loading = true;
        this.ws("get", "reposicionesCajaChica", { id })
          .then(res => {
            if (res.ok) {
              this.reposiciones = res.data;
            } else {
              this.reposiciones = [];
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    prepareDetailForm(data) {
      this.detalleUsuario.nombre =
        data.detalle_usuario.nombre +
        " " +
        data.detalle_usuario.apellido_paterno +
        " " +
        data.detalle_usuario.apellido_materno;
      this.detalleUsuario.nombre = this.detalleUsuario.nombre.trim();
      this.detalleUsuario.puesto = data.detalle_usuario.puesto;
      this.detalleUsuario.departamento = data.detalle_usuario.departamento;
      this.detalleUsuario.oficina = data.detalle_usuario.ubicacion;
      this.detalleUsuario.area = data.solicitud.area;
      this.detalleUsuario.centro = data.solicitud.centro;
      this.detalleUsuario.importe = data.solicitud.importe
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleUsuario.letra = data.solicitud.letra;
      this.detalleUsuario.detalle = data.solicitud.detalle;
      this.detalleUsuario.empresa = data.solicitud.empresa;
      this.detalleUsuario.observaciones = data.solicitud.observaciones;
      this.reposicion.monto = data.solicitud.importe
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.reposicion.banco = data.detalle_usuario.banco;
      this.reposicion.cuenta = data.detalle_usuario.cuenta;
      this.reposicion.tarjeta = data.detalle_usuario.tarjeta;
      this.reposicion.clabe = data.detalle_usuario.clabe;
      this.reposicion.empresa = data.solicitud.empresa;
      this.reposicion.unidad = data.detalle_usuario.unidad;
      this.reposicion.plaza = data.detalle_usuario.plaza;
      this.reposicion.centro = data.solicitud.centro;
      this.reposicion.beneficiario = this.detalleUsuario.nombre;
      this.isReady = true;
      this.refresh();
    },
    detailRequest() {
      let id = this.caja_chica;
      if (id) {
        this.loading = true;
        this.ws("get", "detalleSolicitudCajaChica", { id })
          .then(res => {
            if (res.ok) {
              this.prepareDetailForm(res.data);
              this.refresh();
            } else {
              this.msgError = res.message;
              this.alert = true;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.error = true;
        this.msgError = "Debe seleccionar una caja chica";
      }
    },
    newRequest() {
      this.$router.push("/solicitudes/cajachica");
    },
    prepareForm(data) {
      this.catalogos.centros = data.catalogos.centros;
      this.catalogos.conceptos = data.catalogos.conceptos;
      this.catalogos.conceptos_sat = data.catalogos.conceptos_sat;
      this.catalogos.cajas_chicas = data.catalogos.cajas_chicas;
    },
    newReplacement() {
      let id = this.caja_chica;
      if (id) {
        this.dialogNewRep = true;
      } else {
        this.error = true;
        this.msgError = "Debe seleccionar una caja chica";
      }
    },
    closeNewFac() {
      this.$v.$reset();
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.reposicion.facturas.nueva = {
        tipo_gasto: "deducible",
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        centro: null,
        concepto: "",
        razon_social: "",
        rfc: "",
        no_factura: "",
        fecha_timbrado: "",
        proveedor_frontera: false,
        importe: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.$refs.pdf.value = "";
      this.$refs.xml.value = "";
      this.$refs.foto.value = "";
      this.editNoFactura = false;
      this.dialogNewFac = false;
    },
    saveNewFac() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (
          this.reposicion.facturas.nueva.tipo_gasto === "deducible" &&
          (this.reposicion.facturas.nueva.pdf.data === null ||
            this.reposicion.facturas.nueva.xml.data === null)
        ) {
          this.error = true;
          this.msgError = "Debe adjuntar los archivos PDF y XML";
        } else if (
          this.reposicion.facturas.nueva.tipo_gasto === "no_deducible" &&
          this.reposicion.facturas.nueva.foto.data === null
        ) {
          this.error = true;
          this.msgError = "Debe adjuntar la foto";
        } else if (!this.reposicion.facturas.nueva.centro) {
          this.error = true;
          this.msgError = "Debe seleccionar un centro de costos";
          return false;
        } else if (this.reposicion.facturas.detalle.length < 200) {
          if (this.reposicion.facturas.nueva.tipo_gasto === "deducible") {
            for (let i = 0; i < this.reposicion.facturas.detalle.length; i++) {
              if (
                this.reposicion.facturas.nueva.rfc ==
                this.reposicion.facturas.detalle[i].rfc &&
                this.reposicion.facturas.nueva.no_factura ==
                this.reposicion.facturas.detalle[i].no_factura
              ) {
                this.error = true;
                this.msgError = "La factura ya ha sido guardada anteriormente";
                return false;
              }
            }
            let fecha_actual = moment(moment().format("YYYY-MM-DD"));
            let fecha_factura = moment(
              this.reposicion.facturas.nueva.fecha_timbrado.split("T")[0]
            );
            if (!fecha_factura.isValid()) {
              this.error = true;
              this.msgError = "La fecha de timbrado es incorrecta";
              return false;
            } else if (fecha_actual.diff(fecha_factura, "days") > 30) {
              this.error = true;
              this.msgError =
                "La fecha de timbrado ha superado la antiguedad máxima (30 días)";
              return false;
            }
          }
          let subtotal = parseFloat(
            parseFloat(this.reposicion.facturas.nueva.importe).toFixed(2)
          );
          let descuento = parseFloat(
            parseFloat(this.reposicion.facturas.nueva.descuento).toFixed(2)
          );
          let iva = parseFloat(
            parseFloat(this.reposicion.facturas.nueva.iva).toFixed(2)
          );
          let total = parseFloat(
            parseFloat(this.reposicion.facturas.nueva.total).toFixed(2)
          );
          if (subtotal - descuento <= 2000) {
            for (let i = 0; i < this.reposicion.facturas.detalle.length; i++) {
              subtotal += parseFloat(
                parseFloat(this.reposicion.facturas.detalle[i].importe).toFixed(
                  2
                )
              );
              descuento += parseFloat(
                parseFloat(
                  this.reposicion.facturas.detalle[i].descuento
                ).toFixed(2)
              );
              iva += parseFloat(
                parseFloat(this.reposicion.facturas.detalle[i].iva).toFixed(2)
              );
              total += parseFloat(
                parseFloat(this.reposicion.facturas.detalle[i].total).toFixed(2)
              );
            }
            if (this.reposicion.facturas.nueva.tipo_gasto === "deducible") {
              this.reposicion.facturas.nueva.foto.nombre = "";
              this.reposicion.facturas.nueva.foto.data = "";
            } else if (
              this.reposicion.facturas.nueva.tipo_gasto === "no_deducible"
            ) {
              this.reposicion.facturas.nueva.pdf.nombre = "";
              this.reposicion.facturas.nueva.pdf.data = "";
              this.reposicion.facturas.nueva.xml.nombre = "";
              this.reposicion.facturas.nueva.xml.data = "";
            }
            this.reposicion.facturas.detalle.push({
              tipo_gasto: this.reposicion.facturas.nueva.tipo_gasto,
              pdf: {
                nombre: this.reposicion.facturas.nueva.pdf.nombre,
                data: this.reposicion.facturas.nueva.pdf.data
              },
              xml: {
                nombre: this.reposicion.facturas.nueva.xml.nombre,
                data: this.reposicion.facturas.nueva.xml.data
              },
              foto: {
                nombre: this.reposicion.facturas.nueva.foto.nombre,
                data: this.reposicion.facturas.nueva.foto.data
              },
              centro: this.reposicion.facturas.nueva.centro,
              concepto: this.reposicion.facturas.nueva.concepto,
              razon_social: this.reposicion.facturas.nueva.razon_social,
              rfc: this.reposicion.facturas.nueva.rfc,
              no_factura: this.reposicion.facturas.nueva.no_factura,
              fecha_timbrado: this.reposicion.facturas.nueva.fecha_timbrado,
              importe: parseFloat(
                parseFloat(this.reposicion.facturas.nueva.importe).toFixed(2)
              ),
              descuento: parseFloat(
                parseFloat(this.reposicion.facturas.nueva.descuento).toFixed(2)
              ),
              iva: parseFloat(
                parseFloat(this.reposicion.facturas.nueva.iva).toFixed(2)
              ),
              total: parseFloat(
                parseFloat(this.reposicion.facturas.nueva.total).toFixed(2)
              )
            });
            this.reposicion.facturas.no_facturas = this.reposicion.facturas.detalle.length;
            this.reposicion.facturas.subtotal = subtotal.toFixed(2);
            this.reposicion.facturas.iva = iva.toFixed(2);
            this.reposicion.facturas.importe_total = total.toFixed(2);
            this.closeNewFac();
          } else {
            this.error = true;
            this.msgError =
              "Ha excedido el importe máximo por factura ($2,000.00 MXN)";
          }
        } else {
          this.error = true;
          this.msgError = "Ha llegado al límite de facturas permitidas";
        }
      }
    },
    downloadDocument(doc) {
      let nombre = this.detalleFactura[doc].nombre;
      let data = this.detalleFactura[doc].data;
      if (data !== null && data !== "") {
        let mimetype = data.split(";")[0].split(":")[1];
        download(data, nombre, mimetype);
      } else {
        this.error = true;
        this.msgError = "El documento no se encuentra disponible";
      }
    },
    showDetailFac(idx) {
      this.detalleFactura.index = idx;
      this.detalleFactura.tipo_gasto = this.reposicion.facturas.detalle[
        idx
      ].tipo_gasto;
      this.detalleFactura.pdf.nombre = this.reposicion.facturas.detalle[
        idx
      ].pdf.nombre;
      this.detalleFactura.pdf.data = this.reposicion.facturas.detalle[
        idx
      ].pdf.data;
      this.detalleFactura.xml.nombre = this.reposicion.facturas.detalle[
        idx
      ].xml.nombre;
      this.detalleFactura.xml.data = this.reposicion.facturas.detalle[
        idx
      ].xml.data;
      this.detalleFactura.foto.nombre = this.reposicion.facturas.detalle[
        idx
      ].foto.nombre;
      this.detalleFactura.foto.data = this.reposicion.facturas.detalle[
        idx
      ].foto.data;
      if (this.reposicion.facturas.detalle[idx].centro) {
        this.detalleFactura.centro = this.catalogos.centros.filter(centro => {
          return centro.id == this.reposicion.facturas.detalle[idx].centro;
        })[0].descripcion;
      }
      this.detalleFactura.concepto = this.catalogos.conceptos.filter(
        concepto => {
          return concepto.id == this.reposicion.facturas.detalle[idx].concepto;
        }
      )[0].descripcion;
      this.detalleFactura.razon_social = this.reposicion.facturas.detalle[
        idx
      ].razon_social;
      this.detalleFactura.rfc = this.reposicion.facturas.detalle[idx].rfc;
      this.detalleFactura.no_factura = this.reposicion.facturas.detalle[
        idx
      ].no_factura;
      this.detalleFactura.fecha_timbrado = this.reposicion.facturas.detalle[
        idx
      ].fecha_timbrado;
      this.detalleFactura.importe = this.reposicion.facturas.detalle[
        idx
      ].importe;
      this.detalleFactura.descuento = this.reposicion.facturas.detalle[
        idx
      ].descuento;
      this.detalleFactura.iva = this.reposicion.facturas.detalle[idx].iva;
      this.detalleFactura.total = this.reposicion.facturas.detalle[idx].total;
      this.detalleFactura.importe = parseFloat(this.detalleFactura.importe)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.descuento = parseFloat(this.detalleFactura.descuento)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.iva = parseFloat(this.detalleFactura.iva)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.total = parseFloat(this.detalleFactura.total)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.dialogDetFac = true;
    },
    removeElement() {
      this.questionFac = false;
      this.reposicion.facturas.detalle.splice(this.detalleFactura.index, 1);
      let subtotal = 0;
      let descuento = 0;
      let iva = 0;
      let total = 0;
      for (let i = 0; i < this.reposicion.facturas.detalle.length; i++) {
        subtotal += parseFloat(
          parseFloat(this.reposicion.facturas.detalle[i].importe).toFixed(2)
        );
        descuento += parseFloat(
          parseFloat(this.reposicion.facturas.detalle[i].descuento).toFixed(2)
        );
        iva += parseFloat(
          parseFloat(this.reposicion.facturas.detalle[i].iva).toFixed(2)
        );
        total += parseFloat(
          parseFloat(this.reposicion.facturas.detalle[i].total).toFixed(2)
        );
      }
      this.reposicion.facturas.no_facturas = this.reposicion.facturas.detalle.length;
      this.reposicion.facturas.subtotal = subtotal.toFixed(2);
      this.reposicion.facturas.iva = iva.toFixed(2);
      this.reposicion.facturas.importe_total =
        total > 0 ? total.toFixed(2) : "";
      this.dialogDetFac = false;
    },
    closeDetailFac() {
      this.detalleFactura = {
        index: "",
        tipo_gasto: null,
        pdf: { nombre: "", data: null },
        xml: { nombre: "", data: null },
        foto: { nombre: "", data: null },
        centro: null,
        concepto: "",
        razon_social: "",
        rfc: "",
        no_factura: "",
        fecha_timbrado: "",
        proveedor_frontera: false,
        importe: "",
        descuento: "",
        iva: "",
        total: ""
      };
      this.dialogDetFac = false;
    },
    close() {
      this.$v.$reset();
      this.reposicion.tipoSolicitud = null;
      this.reposicion.tipoPago = null;
      /*this.reposicion.banco = ''
      this.reposicion.cuenta = ''
      this.reposicion.tarjeta = ''
      this.reposicion.clabe = ''*/
      this.color = {
        pdf: "",
        xml: "",
        foto: ""
      };
      this.reposicion.facturas = {
        importe_total: "",
        no_facturas: 0,
        subtotal: 0,
        iva: 0,
        nueva: {
          tipo_gasto: "deducible",
          pdf: { nombre: "", data: null },
          xml: { nombre: "", data: null },
          foto: { nombre: "", data: null },
          centro: null,
          concepto: "",
          razon_social: "",
          rfc: "",
          no_factura: "",
          fecha_timbrado: "",
          proveedor_frontera: false,
          importe: "",
          descuento: "",
          iva: "",
          total: ""
        },
        detalle: []
      };
      this.dialogNewRep = false;
    },
    readFile(doc) {
      return new Promise(() => {
        let fr = new FileReader();
        let file = this.$refs[doc].files;
        let name = file[0].name;
        let size = file[0].size;
        if (size <= 10000000) {
          fr.onload = () => {
            this.reposicion.facturas.nueva[doc].nombre = name;
            this.reposicion.facturas.nueva[doc].data = fr.result;
            this.color[doc] = "success";
            if (doc === "xml") {
              this.reposicion.facturas.nueva.razon_social = "";
              this.reposicion.facturas.nueva.rfc = "";
              this.reposicion.facturas.nueva.no_factura = "";
              this.reposicion.facturas.nueva.fecha_timbrado = "";
              this.reposicion.facturas.nueva.importe = "";
              this.reposicion.facturas.nueva.descuento = "";
              this.reposicion.facturas.nueva.iva = "";
              this.reposicion.facturas.nueva.total = "";
              let xml = decodeURIComponent(
                escape(
                  atob(this.reposicion.facturas.nueva[doc].data.split(",")[1])
                )
              );
              xml = xml.replace(/(\r\n|\n|\r)/g, "");
              let regExp = /cfdi\:Concepto.+ClaveProdServ=\"(\d+)\"/;
              let matches = regExp.exec(xml);
              let cve = "";
              let cuenta = "";
              let subcuenta = "";
              if (matches != null) {
                cve = matches[1];
                for (let i = 0; i < this.catalogos.conceptos_sat.length; i++) {
                  if (this.catalogos.conceptos_sat[i].clave == cve) {
                    cuenta = this.catalogos.conceptos_sat[i].cuenta;
                    subcuenta = this.catalogos.conceptos_sat[i].subcuenta;
                    for (let j = 0; j < this.catalogos.conceptos.length; j++) {
                      if (
                        this.catalogos.conceptos[j].cuenta == cuenta &&
                        this.catalogos.conceptos[j].subcuenta == subcuenta
                      ) {
                        this.reposicion.facturas.nueva.concepto = this.catalogos.conceptos[
                          j
                        ].id;
                      }
                    }
                  }
                }
                if (cuenta == "" || subcuenta == "") {
                  for (let i = 0; i < this.catalogos.conceptos.length; i++) {
                    if (
                      this.catalogos.conceptos[i].cuenta == "12202" &&
                      this.catalogos.conceptos[i].subcuenta == "000000"
                    ) {
                      this.reposicion.facturas.nueva.concepto = this.catalogos.conceptos[
                        i
                      ].id;
                    }
                  }
                }
              } else {
                for (let i = 0; i < this.catalogos.conceptos.length; i++) {
                  if (
                    this.catalogos.conceptos[i].cuenta == "12202" &&
                    this.catalogos.conceptos[i].subcuenta == "000000"
                  ) {
                    this.reposicion.facturas.nueva.concepto = this.catalogos.conceptos[
                      i
                    ].id;
                  }
                }
              }
              regExp = /cfdi\:Emisor.+?Nombre ?=\"([a-zA-Z0-9äÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ,. ]+)\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.razon_social =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Emisor.+?Rfc=\"([A-Z0-9]+)\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.rfc =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?Serie=\"([a-zA-Z0-9/ -]+)\"/;
              matches = regExp.exec(xml);
              let serie = matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?Folio=\"([a-zA-Z0-9/ -]+)\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.no_factura =
                matches != null ? matches[1] : "";
              if (this.reposicion.facturas.nueva.no_factura == "") {
                regExp = /tfd\:TimbreFiscalDigital.+?UUID\s*=\s*\"([a-zA-Z0-9-]+)\"/;
                matches = regExp.exec(xml);
                this.reposicion.facturas.nueva.no_factura =
                  matches != null ? matches[1] : "";
              }
              this.reposicion.facturas.nueva.no_factura =
                serie + this.reposicion.facturas.nueva.no_factura;
              regExp = /FechaTimbrado\s*=\s*\"([^\"]+)\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.fecha_timbrado =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?SubTotal=\"\s*(\d+\.?\d*)\s*\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.importe =
                matches != null ? matches[1] : "";
              regExp = /cfdi\:Comprobante.+?Descuento=\"\s*(\d+\.?\d*)\s*\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.descuento =
                matches != null ? matches[1] : "0.00";
              regExp = /cfdi\:Impuestos.+?TotalImpuestosTrasladados=\"(\d+\.?\d*)\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.iva =
                matches != null ? matches[1] : "0.00";
              regExp = /cfdi\:Comprobante.+? Total=\"(\d+\.?\d*)\"/;
              matches = regExp.exec(xml);
              this.reposicion.facturas.nueva.total =
                matches != null ? matches[1] : "";
              this.editNoFactura =
                this.reposicion.facturas.nueva.no_factura === "" ? true : false;
            }
          };
          fr.onerror = () => {
            this.color[doc] = "";
            this.error = true;
            this.msgError = "El archivo no fue leído correctamente";
          };
          fr.readAsDataURL(file[0]);
        } else {
          this.error = true;
          this.msgError = "El archivo ha excedido el límite permitido (10 MB)";
        }
      });
    },
    save() {
      this.questionRep = false;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let importe_total = parseFloat(
          parseFloat(this.reposicion.facturas.importe_total).toFixed(2)
        );
        let monto = parseFloat(
          parseFloat(this.reposicion.monto.replace(/\,/g, "")).toFixed(2)
        );
        if (importe_total > monto) {
          this.error = true;
          this.msgError = "Ha excedido el monto aprobado de la caja chica";
        } else {
          this.loading = true;
          let data = {
            id: this.caja_chica,
            tipoSolicitud: this.reposicion.tipoSolicitud,
            tipoPago: this.reposicion.tipoPago,
            importe_total: this.reposicion.facturas.importe_total,
            facturas: this.reposicion.facturas.detalle
          };
          this.ws("post", "nuevaReposicionCajaChica", data)
            .then(res => {
              if (res.ok) {
                this.close();
                this.refresh();
                this.success = true;
                this.msgSuccess = res.message;
              } else {
                this.error = true;
                this.msgError = res.message;
              }
            })
            .finally(() => {
              this.loading = false;
            });
          this.loading = false;
        }
      }
    },
    showDetailRep(id) {
      this.loading = true;
      this.idElementoSeleccionado = id;
      this.ws("get", "detalleReposicionCajaChica", { id })
        .then(res => {
          if (res.ok) {
            this.detalleReposicion.general.tipoSolicitud =
              res.data.reposicion.tipo_solicitud;
            this.detalleReposicion.general.tipoPago =
              res.data.reposicion.tipo_pago;
            this.detalleReposicion.general.banco = res.data.reposicion.banco;
            this.detalleReposicion.general.cuenta = res.data.reposicion.cuenta;
            this.detalleReposicion.general.tarjeta =
              res.data.reposicion.tarjeta;
            this.detalleReposicion.general.clabe = res.data.reposicion.clabe;
            this.detalleReposicion.general.importe_total = res.data.reposicion.importe_total
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.detalleReposicion.facturas = res.data.facturas;
            this.detalleReposicion.resumen.no_facturas =
              res.data.facturas.length;
            let subtotal = 0;
            let descuento = 0;
            let iva = 0;
            for (let i = 0; i < res.data.facturas.length; i++) {
              subtotal += parseFloat(
                parseFloat(res.data.facturas[i].importe).toFixed(2)
              );
              descuento += parseFloat(
                parseFloat(res.data.facturas[i].descuento).toFixed(2)
              );
              iva += parseFloat(
                parseFloat(res.data.facturas[i].iva).toFixed(2)
              );
            }
            this.detalleReposicion.resumen.subtotal = subtotal
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.detalleReposicion.resumen.iva = iva
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.detalleReposicion.firmas = res.data.firmas;
            this.dialogDetRep = true;
          } else {
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showFacDetailRep(idx) {
      this.detalleFactura.index = idx;
      this.detalleFactura.tipo_gasto = this.detalleReposicion.facturas[
        idx
      ].tipo_gasto;
      this.detalleFactura.pdf.nombre = this.detalleReposicion.facturas[
        idx
      ].pdf.nombre;
      this.detalleFactura.pdf.data = this.detalleReposicion.facturas[
        idx
      ].pdf.data;
      this.detalleFactura.xml.nombre = this.detalleReposicion.facturas[
        idx
      ].xml.nombre;
      this.detalleFactura.xml.data = this.detalleReposicion.facturas[
        idx
      ].xml.data;
      this.detalleFactura.foto.nombre = this.detalleReposicion.facturas[
        idx
      ].foto.nombre;
      this.detalleFactura.foto.data = this.detalleReposicion.facturas[
        idx
      ].foto.data;
      this.detalleFactura.centro = this.detalleReposicion.facturas[idx].centro;
      this.detalleFactura.concepto = this.detalleReposicion.facturas[
        idx
      ].concepto;
      this.detalleFactura.razon_social = this.detalleReposicion.facturas[
        idx
      ].razon_social;
      this.detalleFactura.rfc = this.detalleReposicion.facturas[idx].rfc;
      this.detalleFactura.no_factura = this.detalleReposicion.facturas[
        idx
      ].no_factura;
      this.detalleFactura.fecha_timbrado = this.detalleReposicion.facturas[
        idx
      ].fecha_timbrado;
      this.detalleFactura.importe = this.detalleReposicion.facturas[
        idx
      ].importe;
      this.detalleFactura.descuento = this.detalleReposicion.facturas[
        idx
      ].descuento;
      this.detalleFactura.iva = this.detalleReposicion.facturas[idx].iva;
      this.detalleFactura.total = this.detalleReposicion.facturas[idx].total;
      this.detalleFactura.importe = this.detalleFactura.importe
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.iva = this.detalleFactura.iva
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.detalleFactura.total = this.detalleFactura.total
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.dialogDetFac = true;
    },
    closeDetailRep() {
      this.detalleReposicion = {
        general: {
          tipoSolicitud: null,
          tipoPago: null,
          monto: "",
          banco: "",
          cuenta: "",
          clabe: "",
          importe_total: ""
        },
        facturas: [],
        resumen: {
          no_facturas: 0,
          subtotal: 0,
          iva: 0
        },
        firmas: []
      };
      this.dialogDetRep = false;
    },
    print() {
      this.loading = true;
      // Abrir ventana inmediatamente para evitar bloqueo de popup
      const pdfWindow = window.open("", "_blank");
      // Mostrar página de carga mientras se genera el PDF
      if (pdfWindow) {
        pdfWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Generando PDF...</title>
            <style>
              body { font-family: Arial, sans-serif; display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; background: #f5f5f5; }
              .loader-container { text-align: center; }
              .spinner { border: 4px solid #e0e0e0; border-top: 4px solid #1976d2; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite; margin: 0 auto 20px; }
              @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
              h2 { color: #333; margin-bottom: 10px; }
              p { color: #666; }
            </style>
          </head>
          <body>
            <div class="loader-container">
              <div class="spinner"></div>
              <h2>Generando PDF</h2>
              <p>Por favor espere, esto puede tomar unos segundos...</p>
            </div>
          </body>
          </html>
        `);
        pdfWindow.document.close();
      }
      let data = {
        idElementoSeleccionado: this.idElementoSeleccionado,
        idCajaChica: this.caja_chica
      };
      this.ws("get", "impresionDetalleReposicion", data)
        .then(res => {
          if (res.ok) {
            this.close();
            this.refresh();
            this.success = true;
            this.msgSuccess = res.message;
            // Redirigir la ventana al PDF
            if (pdfWindow) {
              pdfWindow.location.href = res.data;
            } else {
              window.open(res.data, "_blank");
            }
          } else {
            // Cerrar ventana si hubo error
            if (pdfWindow) {
              pdfWindow.close();
            }
            this.error = true;
            this.msgError = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
